import ChartWrapper from './ChartWrapper'

export { ChartWrapper }
export default ChartWrapper
